export default __webpack_public_path__ + "static/media/20220721-093020.016af3db.jpg";